import { colord, extend } from "colord";
import { communitySwitcherInitials } from "@circleco/community-switcher/helpers/utils";
import { useCommunitySwitcherContext } from "../context/CommunitySwitcherContext";
import a11yPlugin from "colord/plugins/a11y";

extend([a11yPlugin]);

export interface CommunitySwitcherAvatarProps {
  readonly iconUrl: string;
  readonly name: string;
  readonly brandColor?: string;
  readonly lightBrandColor?: string;
  readonly darkBrandColor?: string;
}

export const CommunitySwitcherAvatar = ({
  iconUrl,
  name,
  brandColor,
  lightBrandColor,
  darkBrandColor,
}: CommunitySwitcherAvatarProps) => {
  const { theme } = useCommunitySwitcherContext();
  const bgColor = theme.isDarkAppearance
    ? darkBrandColor
    : lightBrandColor || brandColor;
  const textColor =
    bgColor && colord(bgColor).luminance() > 0.65 ? "#000" : "#fff";

  return (
    <span
      aria-hidden
      className="flex size-9 shrink-0 select-none items-center justify-center overflow-hidden rounded-md"
    >
      {iconUrl ? (
        <img
          alt={`${name} icon`}
          className="size-6 object-cover rounded-md"
          src={iconUrl}
          width={24}
          height={24}
        />
      ) : (
        <span
          className="flex size-6 items-center justify-center rounded-md text-md font-bold leading-none"
          style={
            bgColor ? { backgroundColor: bgColor, color: textColor } : undefined
          }
        >
          {communitySwitcherInitials(name)}
        </span>
      )}
    </span>
  );
};
